module.exports = __webpack_public_path__ + "img/zacatlan.d034f4d4.jpg";